import React, {useContext} from "react"
import {injectIntl} from "react-intl";
import Column from "@amzn/meridian/column";
import {PROTOCOLS} from "../../util/Validations";
import {ZANCASORT_ASSET_TYPE} from "../../util/Constants";
import CommonDeviceLogstream from "../../commonui/CommonDeviceLogstream";
import {ZancaSortDeviceOverviewContext} from "./context/ZancaSortDeviceOverviewContext";

const ZancaSortDeviceLogstream = ({intl}) => {

    const {viewModel, dispatch} = useContext(ZancaSortDeviceOverviewContext);
    const deviceList = Object.values(viewModel.zancaSortDeviceInformation);

    const props = {
        protocols: PROTOCOLS.ZANCASORT,
        dispatch,
        deviceList,
        deviceType: ZANCASORT_ASSET_TYPE,
        intl
    }
    return (
        <Column>
            <CommonDeviceLogstream {...props}/>
        </Column>
    );
}

export default injectIntl(ZancaSortDeviceLogstream)


// WEBPACK FOOTER //
// ./src/components/devicemanagement/zancasort/ZancaSortDeviceLogstream.js